const e = {
  name: "--pf-v6-l-grid--item--Order"
};
export {
  e as default,
  e as l_grid_item_Order
};
